const TrainerSettings = () => {
  return <h1>trainer settings</h1>;
};

export default TrainerSettings;
